import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';// Import useHistory from React Router
import './QuestionsList.css';
import Pagination from '../Pagination/Pagination';
import { AuthContext } from '../../App';
import axios from 'axios';

function QuestionsList({ filters, selectedCompanyFromTrending, resetFilters }) {
    const [questions, setQuestions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const page_size = 50; // Ensure this matches your backend page size
    const [userSubmissions, setUserSubmissions] = useState([]);
    const { isSignedIn, isPremiumUser } = useContext(AuthContext);
    const navigate = useNavigate(); // Instantiate useHistory hook

    // Fetch user submissions
    useEffect(() => {
        // Function to fetch user's submissions
        const fetchUserSubmissions = async () => {
            if (isSignedIn) {
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/get_user_submissions`, { withCredentials: true });
                    // Axios automatically parses the JSON response to 'data', so no need to call .json()
                    const submittedQuestionIds = response.data.map(submission => submission.question_id);
                    setUserSubmissions(submittedQuestionIds);
                } catch (error) {
                    console.error('Error fetching user submissions:', error);
                }
            }
        };

        fetchUserSubmissions();
    }, [isSignedIn]);

    const getStatusElement = (questionId) => {
        if (isSignedIn) {
            return userSubmissions.includes(questionId) ? <span>✔️</span> : null; // Return null if not submitted
        } else {
            return <span className="lock-icon" onClick={handleLockIconClick}>🔒</span>;
        }
    };

    useEffect(() => {
        const fetchQuestions = async () => {
            let queryParams = new URLSearchParams({
                ...filters,
                page: currentPage,
                page_size: page_size,
            });

            if (selectedCompanyFromTrending) {
                queryParams.set('company', selectedCompanyFromTrending);
            }

            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(isSignedIn && { credentials: 'include' })
            };

            try {
                const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/questions?${queryParams}`, requestOptions);
                const data = await response.json();

                if (data.questions) {
                    setQuestions(data.questions);

                    // Use the total_questions from the backend for pagination
                    const totalQuestions = data.total_questions;
                    const newTotalPages = Math.ceil(totalQuestions / page_size);
                    setTotalPages(newTotalPages);
                } else {
                    console.error('No questions field in response:', data);
                    setQuestions([]);
                    setTotalPages(0);
                }
            } catch (error) {
                console.error('Error fetching questions:', error);
            }
        };

        fetchQuestions();
    }, [filters, currentPage, selectedCompanyFromTrending, page_size]);



    useEffect(() => {
        // Reset currentPage to 1 whenever the pageResetIndicator changes
        setCurrentPage(1);
    }, [filters.pageResetIndicator]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    const handleQuestionClick = (question) => {
        navigate(`/practice-question/${question.question_id}`, {
            state: {
                questionNumber: question.question_id, // question ID
                questionTitle: question.question      // question title
            }
        });
    };

    const handleLockIconClick = (e) => {
        e.stopPropagation(); // Prevents the click from triggering the question click handler
        navigate('/signin'); // Redirects to the sign-in page
    };

    return (
        <div className="questions-list-container">
            <div className="questions-list-header">
                <span className="header-status">Status</span>
                <span className="header-title">Title</span>
            </div>
            <div className="questions-list">
                {questions.map((question, index) => (
                    <div key={index} className="question-item" onClick={() => handleQuestionClick(question)}>
                        <span className="status">{getStatusElement(question.question_id)}</span>
                        <span className="title">{`${question.question_id}. ${question.question}`}</span>
                        {/* ... */}
                    </div>
                ))}
            </div>
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    );
}

export default QuestionsList;